/**
 * Handles language and country/currency localization dropdown selectors.
 * @extends HTMLElement
 */
class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure_element'),
    };
    if (this.classList.contains('rr-currency-selector') && typeof Intl.DisplayNames === 'function') {
      try {
        const names = new Intl.DisplayNames([document.documentElement.lang || 'en'], { type: 'currency' });
        this.querySelectorAll('[data-rr-currency]').forEach(label => {
          const code = label.dataset.rrCurrency;
          const name = code === 'EUR' ? 'Euro' : names.of(code);
          label.textContent = name.charAt(0).toLocaleUpperCase() + name.slice(1) + ' (' + code + ' ' + label.dataset.rrSymbol + ')';
        });
      } catch (_) {}
    }
    this.elements.button.addEventListener('click', this.openSelector.bind(this));
    this.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
 
    this.hidePanel();
    this.elements.button.focus();
  }

  /**
   * Sets selected value to hidden input and submits localization form.
   * @param {Event} event
   */
  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    const language = event.currentTarget.dataset.rrLanguage || (this.elements.input.name === 'locale_code' ? event.currentTarget.dataset.value : null);
    const languageInput = form?.querySelector('input[name="language_code"]');
    if (language && languageInput) languageInput.value = language;
    if (language) {
      try { localStorage.setItem('rr-language-choice-v1', language); } catch (_) {}
    }
    if (form) form.submit();
  }

  /** Toggles display state of localization panel and updates accessibility attributes. */
  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
  }

  /**
   * Closes panel if focus leaves component or overlay is clicked.
   * @param {FocusEvent} event
   */
  closeSelector(event) {
    if (event.target.classList.contains('country-selector__overlay') || !this.contains(event.target) || !this.contains(event.relatedTarget)) {
      this.hidePanel();
    }
  }
}

customElements.define('localization-form', LocalizationForm);